import { useCallback } from 'react';
import { FieldValues, UseControllerProps, useController } from 'react-hook-form';
import { VdsField } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';
import { DropdownItemProps } from '../dropdown-items/DropdownItems';
import Dropdown from '../dropdown/Dropdown';

export interface CasFormDropdownProps<TItem, TFormValues extends FieldValues>
  extends UseControllerProps<TFormValues> {
  label?: string;
  items: DropdownItemProps<TItem>[];
  placeholder?: string;
  isReadonly?: boolean;
}

export default function CasFormDropdown<TItem, TFormValues extends FieldValues>(
  props: CasFormDropdownProps<TItem, TFormValues>,
) {
  const { t } = useTranslation();

  const { disabled, ...sanitisedProps } = props;
  const { field, fieldState, formState } = useController(sanitisedProps);

  const { name, label, placeholder } = props;

  const onValueChanged = useCallback(
    (detail: TItem) => {
      field.onChange(detail);
    },
    [field],
  );

  return (
    <VdsField
      key={name}
      label={label ?? ''}
      errorMessage={
        !(props.disabled || field.disabled) && fieldState.error ? fieldState.error.message : ''
      }
      isDisabled={props.disabled || field.disabled || formState.isSubmitting}
    >
      <Dropdown<TItem>
        uid={field.name}
        value={field.value}
        // Todo: Change translation for readonly such as 'No selection'?
        placeholder={placeholder || t('SelectAnOption')}
        disabled={disabled}
        error={fieldState.error !== undefined}
        onBlur={field.onBlur}
        items={props.items}
        onChange={onValueChanged}
        isReadonly={props.isReadonly}
      />
    </VdsField>
  );
}
